import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce3f2158"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "templates" }
const _hoisted_2 = { class: "content-wrapper with-nav" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "item" }, "Templates für WhatsApp-Nachrichten", -1))
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = {
  key: 0,
  class: "table-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_select = _resolveComponent("md-select")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_whatsapp_template_create_overlay = _resolveComponent("whatsapp-template-create-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_md_select, {
        icon: "expand_more",
        modelValue: _ctx.whatsappChannel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.whatsappChannel) = $event)),
        label: "Channel auswählen",
        items: _ctx.selectItems,
        ref: "channelSelect",
        onChange: _ctx.changeChannel
      }, null, 8, ["modelValue", "items", "onChange"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_md_input_field, {
          error: false,
          size: "small",
          variant: "outlined",
          modelValue: _ctx.templateSearch,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.templateSearch) = $event)),
          label: "Suchen nach Template",
          ref: "searchInput",
          icon: "search"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_md_button, {
          variant: "filled",
          onClick: _ctx.openCreateTemplateOverlay
        }, {
          default: _withCtx(() => [
            _createTextVNode("Neues Template erstellen")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      (this.whatsappChannel !== 'none')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_md_table, {
              rows: _ctx.templates,
              onButtonClick: _ctx.onButtonClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_md_table_column, {
                  title: "Name des Templates",
                  display: "name"
                }),
                _createVNode(_component_md_table_column, {
                  title: "Inhalt",
                  display: "content"
                }),
                _createVNode(_component_md_table_column, {
                  title: "Sprachen",
                  display: "language",
                  type: "badge"
                }),
                _createVNode(_component_md_table_column, {
                  title: "Kategorie",
                  display: "category"
                }),
                _createVNode(_component_md_table_column, {
                  title: "Zuletzt aktualisiert",
                  display: "updated"
                }),
                _createVNode(_component_md_table_column, {
                  title: "",
                  display: "delete",
                  type: "button"
                })
              ]),
              _: 1
            }, 8, ["rows", "onButtonClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_whatsapp_template_create_overlay, {
        onClose: _ctx.loadWhatsappTemplates,
        ref: "createTemplateOverlay"
      }, null, 8, ["onClose"])
    ])
  ]))
}